import type { ButtonProps } from 'antd';
import type { ReactNode } from 'react';
import { PermissionButton as BasePermissionButton } from '@wanjianshi/admin-ui';
import { useAdminAuth } from '@/auth/store';

export function PermissionButton({
  permission,
  children,
  ...props
}: ButtonProps & { permission: string; children: ReactNode }) {
  const allowed = useAdminAuth(state => state.hasPermission(permission));
  return <BasePermissionButton allowed={allowed} {...props}>{children}</BasePermissionButton>;
}
